<template>
    <div>
        <p>등록한 영상이 없거나 자동플레이가 안되는 브라우저 환경에서 기본으로 노출됩니다.</p>
        <p>선택한 사전예약 SNS 공유 이미지가 자동으로 설정되며, 필요 시 변경할 수 있습니다.</p>
        <b-form-radio-group buttons button-variant="outline-warning" @change="contentChanged" v-model="pgmAdDto.contentType">
            <b-form-radio value="image">이미지</b-form-radio>
            <b-form-radio value="movie">동영상</b-form-radio>
        </b-form-radio-group>
        <b-form-group v-if="pgmAdDto.contentType === 'image'" class="mb-0">
            <p>업로드할 이미지는 {{width}}x{{height}}px을 권장합니다.(용량은 {{getFileSizeStr}}, jpg 또는 png)</p>
            <!--<div style="width: 530px;">-->
                <!--<vue-dropzone :ref="config.type + lang" :id="config.type + lang" :options="Object.assign({}, dropzoneOptions, {clickable: ['#'+config.type+'UploadBtn'+lang, '#' + config.type +lang], maxFilesize: 0.3, renameFile: renameAndSetDtoProperty.bind(this, { lang: lang, name: 'contentUrl'}), accept: acceptHandlingForDimensionLimit.bind(this, width, height, fileTitle)})"-->
                              <!--v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling" v-on:vdropzone-removed-file="imgRemove.bind(this)" v-on:vdropzone-error="imgErrorHandling" class="mb-2" v-on:vdropzone-sending="$refs[config.type+lang].removeAllFiles(false); $refs[config.type+lang].setOption('maxFiles', null)"></vue-dropzone>-->
            <!--</div>-->
            <!--<b-button type="button" :id="config.type + 'UploadBtn'+lang">upload</b-button>-->
            <!--<b-button type="button" :href="pgmAdDto.contentUrl[lang]" v-if="pgmAdDto.contentUrl[lang]" class="ml-3" target="_blank">download</b-button>-->
            <BtnDropzone :prefixId="config.type"
                         :lang="lang"
                         :width="width" :height="height" :maxSize="maxSize"
                         :acceptedContentTypes="dropzoneOptions.acceptedFiles"
                         :thumbnailTrigger="imgThumbnailTrigger"
                         :dropzoneOptions="dropzoneOptions"
                         :preObject="pgmAdDto.contentUrl"
                         :targetName="lang"
            ></BtnDropzone>
        </b-form-group>
        <b-form-group
                v-else-if="pgmAdDto.contentType === 'movie'"
                :label-class="labelClasses">
            <div style="width:500px">
                <b-embed
                        v-if="pgmAdDto.contentUrl[lang]"
                        type="iframe"
                        aspect="16by9"
                        :src="previewVideoUrl(lang)"></b-embed>
            </div>
            <p>영상을 등록해주세요. 브라우저 환경에 따라 자동재생 되거나 클릭 시 재생됩니다.</p>
            <p>영상은 유튜브와 카카오 TV 도메인만 허용됩니다. (공유 URL을 이용해주세요.)</p>
            <b-form-input id="movieAddr"
                          required
                          v-model="pgmAdDto.contentUrl[lang]" placeholder="영상 URL을 입력해주세요.">
            </b-form-input>
        </b-form-group>
    </div>
</template>

<script>
    import BtnDropzone from '@/views/PlayGame/components/BtnDropzone.vue'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { labelClasses, IMAGE_UPLOAD_URL } from '@/constants'
    import { mapState, mapMutations, mapGetters } from 'vuex'
    import { $showModalWithErrorMsg, addProperty, removeProperty, $imgRemove, renameAndSetDtoProperty, noDropAndDropOver, $getLinkedSvcType, acceptHandlingForDimensionLimit, thumbhnailHandlingForLimtDismension, validationURL } from '@/common/util'
    import { SHOW_MODAL } from '@/store/ui/mutations.type'
    export default {
        name: "ImageVideoSelector",
        components: {
            vueDropzone: vue2Dropzone,
            BtnDropzone
        },
        props: {
            config: Object,
            pgmAdDto: Object,
            maxSize: Number,
            lang: String,
            dropzoneOptions: Object,
            width: Number,
            height: Number,
            imgThumbnailTrigger: Boolean
        },
        data () {
            return {
                labelClasses: labelClasses,

                imgRemove: $imgRemove,
                renameAndSetDtoProperty: renameAndSetDtoProperty,
            }
        },
        created () {
            noDropAndDropOver()
        },
        mounted () {
            if (this.pgmAdDto != null && this.pgmAdDto.contentUrl != null) {
                this.setThumbnail()
            }
        },
        methods: {
            previewVideoUrl (lang) {
                let baseUrl = this.pgmAdDto.contentUrl[lang]
                if (!validationURL(baseUrl)) {
                    this.pgmAdDto.contentUrl[lang] = ''
                    return ''
                }

                let previewUrl = '';

                if(baseUrl.split("://")[0] === 'http') {
                    baseUrl = 'https://' + baseUrl.split("://")[1]
                }

                let youtubeId = baseUrl.split('v=')[1] || baseUrl.split('youtube.com/embed/')[1] || baseUrl.split('youtu.be/')[1]

                if (youtubeId) {
                    previewUrl = 'https://youtube.com/embed/' + youtubeId
                } else {
                    console.log('kakaotv')
                    console.log(baseUrl)
                    let kakaotvId = baseUrl.split('https://tv.kakao.com/v/')[1] || baseUrl.split('/cliplink/')[1]
                    if (kakaotvId) {
                        console.log('kakaotvId')
                        previewUrl = 'https://tv.kakao.com/embed/player/cliplink/' + kakaotvId
                        console.log(previewUrl)
                    }
                }

                this.pgmAdDto.contentUrl[lang] = previewUrl
                return previewUrl
            },
            imgErrorHandling (file, message, xhr) {
            },
            contentChanged() {
                this.pgmAdDto.contentUrl = {}
            },
            setThumbnail() {
                if (this.pgmAdDto.contentUrl['ko'] != null && this.pgmAdDto.contentUrl['ko'] !== '') {
                    this.$refs[this.config.type + 'ko'][0].manuallyAddFile({
                        pregDtoParam: {
                            lang: 'ko',
                            name: 'contentUrl',
                            uploadUrl: this.pgmAdDto.contentUrl['ko'],
                            isMultiple: false,
                            imageObj: 'viewInfo'
                        }
                    }, this.pgmAdDto.contentUrl['ko'])
                }
            },
            acceptHandlingForDimensionLimit: acceptHandlingForDimensionLimit,
            thumbhnailHandlingForLimtDismension: thumbhnailHandlingForLimtDismension,
            ...mapMutations('ui', [SHOW_MODAL])
        },
        computed: {
            getFileSizeStr() {
                return this.maxSize < 1 ? this.maxSize * 1000 + 'KB 이하' : this.maxSize + 'MB 이하'
            },
            ...mapState('preg', [
                'listByAppMasterId'
            ]),
            ...mapGetters('preg', [
                'pregListByAppMasterIdOptionsForBootstrap', 'linkedSvcTypeOptionsForBootstrap', 'osOptionsForBootstrap'
            ])
        },
    }
</script>

<style scoped>

</style>
